const initState = {
  emailContato: {
    nome: "",
    email: "",
    telefone: "",
    mensagem: ""
  },
  errors: {}
}

const email = (state = initState, action = {}) => {
  switch (action.type) {
    case 'SEND_EMAIL_CONTATO_SUCCESS':
      return {
        ...initState,
      };
    case 'ADD_EMAIL_ERROR':
      return {
        ...state,
        errors: action.errors
      };
    default:
      return state;
  }
}

export default email;